/* Designer Consignor Naples — theme.js
   Vanilla JS: mobile menu, cart drawer, AJAX cart (Section Rendering API), gallery, scroll reveal */
(function () {
  'use strict';
  var DCN = window.DCN || { routes: {}, cartType: 'drawer', strings: {} };

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = $('[data-menu-toggle]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) return;
    var close = $('[data-menu-close]', menu);
    var lastFocused = null;
    function focusables() {
      return $all('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', menu)
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      lastFocused = document.activeElement;
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      (close || focusables()[0] || menu).focus();
    }
    function shut() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus(); else toggle.focus();
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    $all('a', menu).forEach(function (a) { a.addEventListener('click', shut); });
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('open')) shut(); });
  }

  /* ---------- Primary nav dropdowns (keyboard + touch; hover = CSS) ---------- */
  function initNav() {
    var items = $all('.nav__item--has');
    if (!items.length) return;
    function closeAll(except) {
      items.forEach(function (o) {
        if (o === except) return;
        o.classList.remove('open');
        var b = o.querySelector('.nav__toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (item) {
      var btn = item.querySelector('.nav__toggle');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = !item.classList.contains('open');
        closeAll(item);
        item.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.nav__item--has')) closeAll(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------- Cart drawer ----------
     Line/body markup comes from the server via the Section Rendering API
     (sections=cart-drawer on /cart/add.js and /cart/change.js), so Liquid
     stays the single source of truth for cart HTML. */
  var Cart = {
    overlay: null, drawer: null, lastFocused: null, _statusT: null,
    init: function () {
      this.overlay = $('[data-drawer-overlay]');
      this.drawer = $('[data-cart-drawer]');
      var self = this;
      $all('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (DCN.cartType !== 'drawer') return; // let it navigate to /cart
          e.preventDefault(); self.open();
        });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      var close = $('[data-cart-close]');
      if (close) close.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.drawer && self.drawer.classList.contains('open')) self.close();
        self.trapTab(e);
      });
      this.bindLineEvents();
    },
    open: function () {
      if (!this.drawer) return;
      this.lastFocused = document.activeElement;
      this.drawer.classList.add('open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      var closeBtn = this.drawer.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') this.lastFocused.focus();
    },
    trapTab: function (e) {
      if (e.key !== 'Tab' || !this.drawer || !this.drawer.classList.contains('open')) return;
      var f = Array.prototype.slice.call(this.drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    bindLineEvents: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var change = e.target.closest('[data-line-change]');
        if (change) { e.preventDefault(); self.changeLine(change.getAttribute('data-line-key'), parseInt(change.getAttribute('data-line-qty'), 10)); }
        var remove = e.target.closest('[data-line-remove]');
        if (remove) { e.preventDefault(); self.changeLine(remove.getAttribute('data-line-key'), 0); }
      });
    },
    changeLine: function (key, qty) {
      var self = this;
      var refocusSel = null;
      var ae = document.activeElement;
      if (ae && this.drawer && this.drawer.contains(ae) && ae.getAttribute('data-line-key') === key) {
        refocusSel = ae.hasAttribute('data-line-remove') ? '[data-line-remove]' : '[data-line-dir="' + ae.getAttribute('data-line-dir') + '"]';
      }
      fetch(DCN.routes.cart_change_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' })
      }).then(function (r) { if (!r.ok) throw new Error('cart change failed'); return r.json(); })
        .then(function (cart) {
          self.renderSection(cart.sections && cart.sections['cart-drawer']);
          self.updateCount(cart.item_count);
          var line = null;
          (cart.items || []).forEach(function (it) { if (it.key === key) line = it; });
          if (qty > 0 && line && line.quantity < qty) self.status(DCN.strings.maxInBag);
          self.refocusLine(key, refocusSel);
        })
        .catch(function () { window.location.href = DCN.routes.cart_url; });
    },
    renderSection: function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newBody = doc.querySelector('[data-cart-body]');
      var body = $('[data-cart-body]');
      if (newBody && body) body.innerHTML = newBody.innerHTML;
      var newFoot = doc.querySelector('[data-cart-foot]');
      var foot = $('[data-cart-foot]');
      if (newFoot && foot) { foot.innerHTML = newFoot.innerHTML; foot.hidden = newFoot.hasAttribute('hidden'); }
      var wrap = doc.querySelector('[data-cart-drawer]');
      if (wrap) this.updateCount(parseInt(wrap.getAttribute('data-cart-drawer-count'), 10) || 0);
    },
    refocusLine: function (key, sel) {
      if (!this.drawer || !this.drawer.classList.contains('open')) return;
      var target = null;
      if (sel && key && window.CSS && CSS.escape) {
        target = this.drawer.querySelector('[data-line-key="' + CSS.escape(key) + '"]' + sel);
        if (target && target.disabled) target = this.drawer.querySelector('[data-line-key="' + CSS.escape(key) + '"][data-line-remove]');
      }
      if (!target) target = this.drawer.querySelector('[data-cart-close]');
      if (target) target.focus();
    },
    status: function (msg) {
      var el = $('[data-cart-status]');
      if (!el || !msg) return;
      el.textContent = msg;
      clearTimeout(this._statusT);
      this._statusT = setTimeout(function () { el.textContent = ''; }, 4000);
    },
    updateCount: function (count) {
      $all('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
  };

  /* ---------- AJAX add to cart ---------- */
  function initAddToCart() {
    $all('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (DCN.cartType !== 'drawer') return; // standard POST to /cart/add
        e.preventDefault();
        var btns = $all('[type="submit"]', form);
        if (form.id) btns = btns.concat($all('[type="submit"][form="' + form.id + '"]'));
        btns = btns.filter(function (b) { return !b.disabled; });
        var errEl = $('[data-product-error]');
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        var originals = btns.map(function (b) { return b.textContent; });
        btns.forEach(function (b) { b.disabled = true; b.textContent = DCN.strings.adding || 'Adding…'; });
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fetch(DCN.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw { handled: true, data: data }; return data; }); })
          .then(function (data) {
            Cart.renderSection(data.sections && data.sections['cart-drawer']);
            Cart.open();
            Cart.status(DCN.strings.addedToCart);
          })
          .catch(function (err) {
            if (err && err.handled) {
              var msg = (err.data && (err.data.description || err.data.message)) || DCN.strings.addError || 'Unable to add this piece.';
              if (errEl) {
                errEl.textContent = msg;
                errEl.hidden = false;
                if (errEl.scrollIntoView) errEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
              }
            } else {
              form.submit(); // network failure — fall back to the native POST
            }
          })
          .finally(function () {
            btns.forEach(function (b, i) { b.disabled = false; b.textContent = originals[i]; });
          });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    var main = $('[data-gallery-main]', gallery);
    $all('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) {
          main.src = thumb.getAttribute('data-full');
          main.srcset = thumb.getAttribute('data-srcset') || '';
        }
        $all('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $all('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initNav();
    Cart.init();
    initAddToCart();
    initGallery();
    initReveal();
  });
})();
